import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { compareStrings } from '@cbridge-utils/object';
import { ICoverageAccount } from '../coverageAccount.interface';
import { coverageAccountStoreSelector } from '../coverageAccount.selector';

export const coverageAccountListSelector = createCachedSelector(
  [
    path(coverageAccountStoreSelector).data(),
    path(coverageAccountStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    const list: ICoverageAccount[] = Object.values(data)
      .sort((a, b) => compareStrings(a.name, b.name));
    return { list, networkStatus };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
